import { isIOS } from "@helpers/platform";
import useBreakpoints from "@memorang/ui/useBreakpoints";

export const useDevice = () => {
	const { smDown, mdDown, smUp, lgUp, xxsDown } = useBreakpoints();
	const isMediumWindowSize = smUp && mdDown;

	const isLargeWindowSize = lgUp;
	const isIpad = isIOS && smUp;

	const isSmallScreen = xxsDown;
	return {
		isMobile: smDown,
		isMediumWindowSize,
		isLargeWindowSize,
		isIpad,
		isSmallScreen,
	};
};
